import Box from "@mui/material/Box";
import { Conversation, Participant } from "../../stores/ChatClientStore";
import useChatClient from "../../hooks/useChatClient";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avatar from "@mui/material/Avatar";
import { ReactNode } from "react";
import Typography from "@mui/material/Typography";
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import IconButton from "@mui/material/IconButton";

type Props = {

}

function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
}

const ChatBotSummary = ({ }: Props) => {
    const {
        setShowChatWindow,
        requestHelp
    } = useChatClient();

    return (
        <Box onClick={() => setShowChatWindow()}>
            <Box display='flex' alignItems='center' gap={2} justifyContent='space-between'>
                <Box display='flex' alignItems='center' gap={2}>
                    <AvatarGroup >
                        <Avatar sx={
                            {
                                width: 34, height: 34,
                                bgcolor: stringToColor('Chatbot'),
                            }}
                            children={`CB`} />
                    </AvatarGroup>

                    <Box>
                        <Typography noWrap>
                            Ask a Question
                        </Typography>
                    </Box>
                </Box>

                <IconButton title='Request Help' onClick={requestHelp }>
                    <ContactSupportIcon />
                </IconButton>
            </Box>
        </Box>
    )
}

export default ChatBotSummary;